import { createAction } from 'redux-act';

export const setSettings = createAction<any>();
export const setDisplayOff = createAction();
export const setDisplayOn = createAction();
export const setLayout = createAction<any>();
export const setPageTitle = createAction<string>();
export const setAuthSuccessLayout = createAction();
export const setAuthFailureLayout = createAction();
export const setMobileOrientation = createAction<any>('set mobile mode');
export const setRoute = createAction<any>('set route');
